import chardet from 'chardet';
import Papa from 'papaparse';

import { LoaderResult } from '../../types';

const DEFAULT_ENCODING = 'UTF-8';

export const csvLoader = (file: File): Promise<LoaderResult> => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    try {
      const encoding = await getCSVFileEncoding(file);
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        encoding,
        error: reject,
        complete: (parseResult) => {
          if (parseResult.errors.length > 0) {
            return reject(parseResult.errors);
          }
          return resolve({ data: parseResult.data });
        },
      });
    } catch (error) {
      reject(error);
    }
  });
};

const getCSVFileEncoding = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      if (!e.target?.result) {
        return reject('Could not read file content and get encoding.');
      }
      resolve(chardet.detect(new Uint8Array(e.target.result as ArrayBuffer)) ?? DEFAULT_ENCODING);
    };
    reader.readAsArrayBuffer(file);
  });
};
